<template>
  <div class="education-page" v-if="translations">
    <template v-if="!isLoading">
      <div class="education-page__container">
        <h1 class="education-page__heading">{{ article.title }}</h1>

        <div
          class="education-page__description cms-content"
          v-html="article.content"
          v-on:click="handleContentClick($event)"
        ></div>
      </div>

      <WasThisUseful
        v-if="article.id"
        :title="article.title"
        :id="article.id.toString()"
        :type="'education'"
      />
    </template>
    <template v-else>
      <v-container>
        <div class="education-page__loading">
          <LoadingSpinner :spinner-text="translations.toolkit.loading" />
        </div>
      </v-container>
    </template>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";
import LoadingSpinner from "../components/App/LoadingSpinner.vue";
import WasThisUseful from "@/components/WasThisUseful/WasThisUseful";

export default {
  components: {
    LoadingSpinner,
    WasThisUseful,
  },
  data() {
    return {
      article: [],
      isLoading: false,
    };
  },
  computed: {
    translations() {
      return hubbdata.getters.translations;
    },
  },
  methods: {
    async educationArticle() {
      this.isLoading = true;
      try {
        const params = new URLSearchParams({
          populate: "*",
          locale: localStorage.getItem("current_lang"),
        });

        const response = await fetch(
          `https://mentalhealthhub.focusgov.co.uk/api/educations/${this.$route.params.id}?${params}`,
          {
            method: "GET",
            mode: "cors",
            credentials: "omit",
            headers: {
              Accept: "application/json",
            },
          }
        );
        const data = await response.json();
        this.article = data.data;
      } catch (err) {
        this.article = [];
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.educationArticle();

    this.$bus.$on("language-changed-from-header", () => {
      this.educationArticle();
    });
  },
};
</script>